<template>
  <div>
    <div class="orderlist">
      <div class="title">个人订单</div>
      <div class="detail">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="购买权限">
            <template slot-scope="scope">
              <div class="cell-box limit">
                <div class="up">
                  <span class="time">{{scope.row.payTime}}</span>
                  <span class="orderNo">订单号：{{scope.row.orderNo}}</span>
                </div>
                <div class="down">{{scope.row.goodsDesc}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="有效期" width="100" align="center">
            <template slot-scope="scope">
              <div class="cell-box">
                <div class="up"></div>
                <div class="down">{{scope.row.goodsTime}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="实付款" width="100" align="center">
            <template slot-scope="scope">
              <div class="cell-box">
                <div class="up"></div>
                <div class="down">￥{{ scope.row.amount }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="cell-box last">
                <div class="up"></div>
                <div class="down btns">
                  <!-- <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">订单详情</el-button> -->
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleInvoice(scope.row)"
                  >{{scope.row.invoiceFlag ? '查看发票' : '开具发票'}}</el-button>
                  <el-popover trigger="click" placement="top" popper-class="contact">
                    <div class="row">
                      <div class="contact-title">联系电话:</div>
                      <div class="phone">010-65185898 |+86 15210925572</div>
                    </div>
                    <div class="row">
                      <div class="contact-title">添加微信客服:</div>
                      <div class="img">
                        <img class="server" src="@/assets/img/code.jpg" alt />
                      </div>
                    </div>
                    <div class="contact-title">工作时间:</div>
                    <div class="contact-title">法定工作日，周一至周五</div>
                    <div class="contact-title">09:00~18:00</div>
                    <div slot="reference" class="name-wrapper">
                      <el-button type="text" size="mini">联系客服</el-button>
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="currentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderList } from "@/api/product";
export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 5
    };
  },
  components: {},
  created() {
    this.getTableData(this.currentPage);
  },
  methods: {
    async getTableData(pageNo) {
      let params = {
        pageNum: pageNo,
        pageSize: this.pageSize
      };
      let { data } = await getOrderList(params);
      this.tableData = data.resultBody.list;
      this.total = data.resultBody.total;
    },
    handleInvoice(row) {
      this.$emit("showInvoiceDialog", {
        isOpen: true,
        orderNo: row.orderNo,
        invoiceFlag: row.invoiceFlag
      });
    },
    currentChange(val) {
      this.currentPage = val;
      this.getTableData(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.orderlist {
  text-align: center;
  .title {
    font-size: 18px;
    height: 40px;
    border-bottom: 1px solid #c1c1c1;
  }
  .detail {
    .cell-box {
      .up {
        background: #eeeeee;
        color: #757575;
        font-size: 12px;
        height: 24px;
        padding-left: 20px;
        .time {
          margin-right: 50px;
        }
      }
      .down {
        padding-top: 20px;
      }
      .btns {
        display: flex;
        flex-direction: column;
        .el-button + .el-button {
          margin-left: 0;
        }
        .el-button--text {
          color: #4b4b4b;
        }
      }
    }
    .limit {
      .down {
        padding-left: 20px;
      }
    }
    .el-table /deep/ .cell {
      padding-left: 0;
      padding-right: 0;
    }
    /deep/ .el-table__header-wrapper {
      th.is-leaf {
        border-bottom: none;
        font-size: 12px;
      }
    }
    /deep/ .el-table__body-wrapper {
      td {
        padding: 0 0 20px;
        vertical-align: top;
        font-size: 12px;
      }
    }
  }
  .page {
    height: 50px;
    padding-top: 20px;
    text-align: right;
  }
}
</style>
<style lang="scss">
.el-popper.contact {
  .row {
    margin-bottom: 10px;
  }
  .img {
    text-align: center;
    .server {
      width: 70px;
      height: 70px;
    }
  }
  .contact-title {
    font-size: 12px;
  }
  .phone {
    font-weight: 700;
  }
}
</style>